import useFilterAnalysisCore from "./core/useFilterAnalysisCore"


export const useFilterAnalysis = () => {
    return useFilterAnalysisCore()
}